import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { queryParamSelector, RouterAction } from '@cbridge-packages/routing';
import { ServersFilterAction } from '../serversFilter.action';
import { ServerParam } from '../_helpers/serverSearchParam';

type IState =
  & IGetSelectorStateType<typeof queryParamSelector>;

export const toggleSelectServerEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(ServersFilterAction.toggleSelect),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { serverId } = payload;
    const currentId = queryParamSelector(state, ServerParam.name);

    if (String(serverId) === currentId) {
      return [
        RouterAction.removeParam(ServerParam.name),
      ];
    }
    return [
      RouterAction.addParam(ServerParam.nameAndValue(String(serverId))),
    ];
  }),
);
